import { Button, Card, Stack, Typography, useTheme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { invitationApi } from 'src/api/invitation';
import Iconify from 'src/components/iconify';
import OrganizationInvitesAddModal from 'src/sections/@dashboard/organization/components/OrganizationDetails/OrganizationInvites/OrganizationInvitesAddModal';
import OrganizationInvitesListTable from 'src/sections/@dashboard/organization/components/OrganizationDetails/OrganizationInvites/OrganizationInvitesListTable';
import { translateKey } from 'src/locales/translate';


export default function OrganizationDetailsInvitesTabsPage() {
  const theme = useTheme();
  const { organizationId } = useParams();
  const { data, isError, isLoading, refetch } = useQuery(
    ['organization-invites', organizationId],
    () =>
      invitationApi.invitationControllerGetInvitationsByOrganization({
        organizationId: organizationId!,
      }),
    {
      retry: 2,
    },
  );
  const invites = data?.data || [];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Card
        sx={{
          height: '100%',
          display: 'flex',
          flex: 1,
          boxShadow: theme.customShadows.z24,
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px', flex: 1 }}>
          <Stack
            sx={{ minHeight: '84px' }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            p={3}
          >
            <Typography variant="h6">Zaproszenia</Typography>
            <Button
              variant="contained"
              sx={{
                background: theme.palette.common.black,
                color: theme.palette.common.white,
              }}
              startIcon={
                <Iconify width="24px" height="24px" icon="ic:round-plus" />
              }
              onClick={openModal}
            >{translateKey("hardcoded.zapros")}</Button>
          </Stack>
          <OrganizationInvitesListTable
            invites={invites}
            isError={isError}
            isLoading={isLoading}
            fetchInvites={refetch}
          />
        </Stack>
      </Card>

      <OrganizationInvitesAddModal
        isOpen={isModalOpen}
        onClose={closeModal}
        fetchInvites={refetch}
      />
    </>
  );
}
